// extracted by mini-css-extract-plugin
module.exports = {"workHistoryContainer":"QQnM0WWK","workHistoryContainerFirst":"_3vRzh15U","showDetails":"_3IuuqvMj","showDetailsIcon":"_3NOA_hyx","workNameContainer":"p9OGXAHs"};
    if(module.hot) {
      // 1754514976255
      var cssReload = require("!../../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  